export default "__VITE_ASSET__DluCLB$L__"